import React from 'react';
import { FadeIn } from './FadeIn';
export function PreguntasFrecuentes() {
  const faqs = [{
    q: '¿Cuándo recibo acceso?',
    a: 'Inmediatamente después de realizar el pago seguro.'
  }, {
    q: '¿Necesito experiencia?',
    a: 'No. El sistema está diseñado paso a paso para principiantes.'
  }, {
    q: '¿Cuánto dinero necesito para comenzar?',
    a: 'Puedes empezar con poco presupuesto usando el modelo FBM.'
  }, {
    q: '¿Cómo accedo al curso?',
    a: 'Recibirás un correo con el enlace de descarga instantánea.'
  }, {
    q: '¿Las actualizaciones están incluidas?',
    a: 'Sí, recibes todas las mejoras futuras sin costo adicional.'
  }];
  return <section className="bg-brand-beige/30 py-20 md:py-32 px-4 sm:px-6" data-id="element-525">
      <div className="max-w-3xl mx-auto" data-id="element-526">
        <FadeIn data-id="element-527">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-brand-green text-center mb-16 tracking-tight" data-id="element-528">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-529">
          {faqs.map((faq, i) => <FadeIn key={i} delay={0.05 * i} data-id="element-530">
              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-brand-text/5" data-id="element-531">
                <h3 className="text-lg sm:text-xl font-bold text-brand-green mb-2" data-id="element-532">
                  {faq.q}
                </h3>
                <p className="text-brand-text/70 leading-relaxed" data-id="element-533">{faq.a}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}